import React from 'react';
import logo_white from '../../../Assets/images/logo_white.svg'

function Footer() {
  return (
    <footer id="FooterZone">
      <section id="Footer" className="footer dark-bg">
        <div className="top-foot nlf-top-spaced-between-wrap">
          <div className="contact-info fifth">
            <a href="/" className="foot-logo">
              <img alt="DoodyCalls" src={logo_white} width="244" height="53" />
            </a>
            <strong>Call for a Free Quote</strong>
            <a href="tel:(888) 659-6558" id="Footer_3">(888) 659-6558</a>
          </div>
          <ul className="quick-links three-fifths nlf-top-wrap">
            <li className="third">
              <a href="https://www.doodycalls.com/about-us/" target="_blank" rel="noopener noreferrer">About Us</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/residential-services/" target="_blank" rel="noopener noreferrer">Residential Services</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/commercial-services/" target="_blank" rel="noopener noreferrer">Commercial Services</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/franchising/" target="_blank" rel="noopener noreferrer">Franchising</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/locations/" target="_blank" rel="noopener noreferrer">Locations</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/contact-us/" target="_blank" rel="noopener noreferrer">Contact Us</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/press-kit/" target="_blank" rel="noopener noreferrer">Press Kit</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/about-us/employment/" target="_blank" rel="noopener noreferrer">Careers</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/ada-notice/" target="_blank" rel="noopener noreferrer">ADA Notice</a>
            </li>
            <li className="third">
              <a href="https://www6.myfranconnect.com/doodycalls/" target="_blank" rel="noopener noreferrer">Franchise Login</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </li>
            <li className="third">
              <a href="https://www.doodycalls.com/sitemap.xml" target="_blank" rel="noopener noreferrer">Site Map</a>
            </li>
            <li className="third">
            <a href="https://www.doodycalls.com/privacy-policy/consumer-protection/">Your Privacy Choices</a>
            </li>
          </ul>
          <div className="fifth">
            <div className="footer-social ui-repeater" id="ctl02">
              <strong>Follow Us</strong>
              <ul className="social">
                <li data-item="i">
                  <a href="https://twitter.com/doodycallshq" title="twitter" aria-label="twitter" target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 36 36" data-use="/cms/svg/admin/cbgeyb6wxx8.36.2108021144467.svg#twitter">
                      <path d="M25.3 3.379C21.146 3.379 18.125 6.452 18.125 10.383C18.125 10.874 18.125 11.243 18.251 11.489L18.125 11.489C10.951 11.489 6.168 10.014 2.518 5.59C1.888 6.697 1.259 7.803 1.259 9.154C1.259 11.611 2.895 13.7 4.909 15.051L4.909 15.051C3.65 15.051 2.266 14.438 1.259 13.823L1.259 13.823C1.259 17.386 6.294 21.44 9.692 22.055C9.251 22.485 8.439 22.629 7.548 22.629C5.898 22.629 3.977 22.135 3.65 22.055L3.65 22.055C4.657 24.88 7.678 26.723 10.825 26.723C8.307 28.69 5.286 29.672 1.762 29.672C1.133 29.672 0.629 29.672 0 29.55L0 29.55C3.272 31.637 7.803 32.621 12.083 32.621C25.678 32.621 32.601 22.177 32.601 12.594C32.601 12.225 32.601 11.734 32.601 11.365C33.859 10.505 35.118 9.154 36 7.68L36 7.68C34.615 8.294 32.727 9.032 31.216 9.154C32.727 8.294 34.237 6.205 34.866 4.485L34.866 4.485C33.733 5.223 32.349 6.083 30.964 6.574L30.083 5.714C28.699 4.363 27.44 3.379 25.3 3.379Z"></path>
                    </svg>
                  </a>
                </li>
                <li data-item="i">
                  <a href="https://www.facebook.com/DoodyCalls/" title="facebook" aria-label="facebook" target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 36 36" data-use="/cms/svg/admin/cbgeyb6wxx8.36.2108021144467.svg#facebook">
                      <path d="M20.762 0C14.563 0 13.152 4.601 13.152 7.544L13.152 11.658L9.562 11.658L9.562 18.016L13.144 18.016C13.144 26.175 13.144 36 13.144 36L20.684 36C20.684 36 20.684 26.076 20.684 18.016L25.77 18.016L26.438 11.658L20.692 11.658L20.692 7.924C20.692 6.517 21.628 6.191 22.287 6.191L26.345 6.191L26.345 0.024L20.762 0Z"></path>
                    </svg>
                  </a>
                </li>
                <li data-item="i">
                  <a href="https://www.pinterest.com/doodycallshq/_created/" title="pinterest" aria-label="pinterest" target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 36 36" data-use="/cms/svg/admin/cbgeyb6wxx8.36.2108021144467.svg#pinterest">
                      <path d="M18.839 0c-9.822 0-14.775 7.045-14.775 12.915 0 3.561 1.35 6.721 4.232 7.899 0.475 0.193 0.9 0.011 1.037-0.513 0.095-0.366 0.32-1.283 0.422-1.666 0.141-0.513 0.084-0.696-0.295-1.15-0.833-0.981-1.364-2.257-1.364-4.057 0-5.224 3.909-9.903 10.18-9.903 5.554 0 8.606 3.396 8.606 7.924 0 5.962-2.64 10.993-6.556 10.993-2.165 0-3.783-1.789-3.262-3.983 0.622-2.622 1.824-5.449 1.824-7.337 0-1.694-0.91-3.104-2.788-3.104-2.211 0-3.99 2.285-3.99 5.35 0 1.955 0.664 3.273 0.664 3.273s-2.267 9.59-2.661 11.267c-0.791 3.343-0.12 7.446-0.06 7.86 0.032 0.243 0.345 0.306 0.489 0.12 0.204-0.267 2.84-3.522 3.733-6.771 0.257-0.921 1.455-5.677 1.455-5.677 0.721 1.367 2.816 2.573 5.052 2.573 6.648 0 11.154-6.057 11.154-14.174-0.007-6.131-5.203-11.843-13.098-11.843z"></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <a href="https://app.doodycalls.com/" target="_blank" rel="noopener noreferrer" className="btn">Free Quote</a>
          </div>
        </div>
        <small className="disclaimer">
          <p>
                © 2021 DoodyCalls, LLC. All rights reserved.<br/>
                DoodyCalls is the nation’s trusted leader in pet waste removal services for homeowners and communities. 
                Doody is our duty, and we take our job seriously—with all our services 100% guaranteed.
          </p>
          <p>
                *Prices vary by location. Get a <a href="https://app.doodycalls.com/" target="_blank" rel="noopener noreferrer">free instant quote</a> for more details.
          </p>
          <p>
                California and General Disclaimer: We do not make any claims regarding DoodyCalls bags in terms of “biodegradable” or “degradable” or “compostable” 
                or in any way imply that the bags will break down in a landfill. 
                In addition, DoodyCalls bags do not meet the California ASTM D6400 standard for biodegradable plastic bags. 
                We do not respond to Do Not Track signals.
          </p>
        </small>
      </section>
    </footer>
    
  );
}

export default Footer;